/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LedgerBoardPrizeTier } from './LedgerBoardPrizeTier';
import {
    LedgerBoardPrizeTierFromJSON,
    LedgerBoardPrizeTierFromJSONTyped,
    LedgerBoardPrizeTierToJSON,
    LedgerBoardPrizeTierToJSONTyped,
} from './LedgerBoardPrizeTier';

/**
 * 
 * @export
 * @interface LedgerBoardPrizeLadderResponse
 */
export interface LedgerBoardPrizeLadderResponse {
    /**
     * Deepest paying rank across every tier — the "Top N" to print.
     * @type {number}
     * @memberof LedgerBoardPrizeLadderResponse
     */
    payingPlaces: number;
    /**
     * 
     * @type {Array<LedgerBoardPrizeTier>}
     * @memberof LedgerBoardPrizeLadderResponse
     */
    tiers: Array<LedgerBoardPrizeTier>;
}

/**
 * Check if a given object implements the LedgerBoardPrizeLadderResponse interface.
 */
export function instanceOfLedgerBoardPrizeLadderResponse(value: object): value is LedgerBoardPrizeLadderResponse {
    if (!('payingPlaces' in value) || value['payingPlaces'] === undefined) return false;
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    return true;
}

export function LedgerBoardPrizeLadderResponseFromJSON(json: any): LedgerBoardPrizeLadderResponse {
    return LedgerBoardPrizeLadderResponseFromJSONTyped(json, false);
}

export function LedgerBoardPrizeLadderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerBoardPrizeLadderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'payingPlaces': json['payingPlaces'],
        'tiers': ((json['tiers'] as Array<any>).map(LedgerBoardPrizeTierFromJSON)),
    };
}

export function LedgerBoardPrizeLadderResponseToJSON(json: any): LedgerBoardPrizeLadderResponse {
    return LedgerBoardPrizeLadderResponseToJSONTyped(json, false);
}

export function LedgerBoardPrizeLadderResponseToJSONTyped(value?: LedgerBoardPrizeLadderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payingPlaces': value['payingPlaces'],
        'tiers': ((value['tiers'] as Array<any>).map(LedgerBoardPrizeTierToJSON)),
    };
}

